/*
 * Recently viewed products.
 * Reads the localStorage list written by snippets/recently-viewed-track.liquid,
 * drops the product currently being viewed, fetches each product's native card via
 * the Section Rendering API (?section_id=recently-viewed-product), and injects the
 * cards as slides into the reusable slider (snippets/slider.liquid). The section is
 * hidden until it has cards so empty history never shows a blank block.
 */
(function () {
  var KEY = 'inspire:recently-viewed';

  function cardUrl(url, section) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + section;
  }

  function fetchCard(url, section) {
    var ck = 'inspire:rvcard:' + url;
    try {
      var cached = sessionStorage.getItem(ck);
      if (cached !== null) return Promise.resolve(cached);
    } catch (e) {}
    return fetch(cardUrl(url, section))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var el = new DOMParser().parseFromString(text, 'text/html').querySelector('.rv-card-render');
        var html = el ? el.innerHTML.trim() : '';
        try { sessionStorage.setItem(ck, html); } catch (e) {}
        return html;
      })
      .catch(function () { return ''; });
  }

  function reveal(section) {
    section.hidden = false;
    section.removeAttribute('style');
  }

  function refreshSlider(slider) {
    if (!slider) return;
    // Re-query slides and rebuild pages; the slider's own ResizeObserver + Dawn's
    // SliderComponent then recompute pagination and hide the arrows when 1 page.
    if (typeof slider.resetPages === 'function') {
      customElements.whenDefined('slider-component').then(function () {
        requestAnimationFrame(function () { slider.resetPages(); });
      });
    }
  }

  function load(section, items) {
    var ul = section.querySelector('[id^="Slider-"]');
    if (!ul) return;
    var slider = ul.closest('slider-component');
    var productSection = section.dataset.productSection || 'recently-viewed-product';
    var pending = items.length;

    reveal(section);

    items.forEach(function (p, index) {
      var li = document.createElement('li');
      li.id = 'Slide-' + section.dataset.sectionId + '-' + (index + 1);
      li.className = 'grid__item slider__slide';
      ul.appendChild(li);
      fetchCard(p.url, productSection).then(function (html) {
        if (html) {
          li.innerHTML = html;
        } else if (li.parentNode) {
          li.parentNode.removeChild(li);
        }
        pending -= 1;
        if (pending <= 0) refreshSlider(slider);
      });
    });
  }

  function init(section) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) {}
    if (!Array.isArray(list)) list = [];

    var currentId = null;
    var pi = document.querySelector('product-info');
    if (pi && pi.dataset.productId) currentId = parseInt(pi.dataset.productId, 10);

    var max = parseInt(section.dataset.max, 10) || 8;
    var items = list.filter(function (p) {
      return p && p.id && p.url && p.id !== currentId;
    }).slice(0, max);

    var note = section.querySelector('[data-rv-note]');

    if (items.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          if (entries[0].isIntersecting) {
            obs.disconnect();
            load(section, items);
          }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(section);
      } else {
        load(section, items);
      }
    } else if (section.dataset.designMode === 'true') {
      if (note) note.hidden = false;
      reveal(section);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-recently-viewed]').forEach(function (s) { init(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
